<template>
  <span>{{ formattedDate }}</span>
</template>

<script>
export default {
  name: 'DateFormatter',
  props: {
    date: {
      type: String,
      required: true
    }
  },
  computed: {
    formattedDate() {
      const date = new Date(this.date)
      
      const months = ['January', 'February', 'March', 'April', 'May', 'June', 
                     'July', 'August', 'September', 'October', 'November', 'December']
      
      const month = months[date.getMonth()]
      const day = date.getDate()
      const year = date.getFullYear()
      const hours = date.getHours()
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const period = hours >= 12 ? 'pm' : 'am'
      const formattedHours = hours % 12 || 12
      
      return `${month} ${day}, ${year} - ${formattedHours}:${minutes} ${period}`
    }
  }
}
</script>